import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {LandingComponent} from './landing/landing.component';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzImageModule} from 'ng-zorro-antd/image';
import {NzSpinModule} from 'ng-zorro-antd/spin';

/**
 * Includes a single component called LandingComponent.
 *
 * Note: `NzMessageModule` was removed in ng-zorro-antd v20. `NzMessageService`
 * is now `providedIn: 'root'` and consumers can inject it directly, so no
 * module import is required here.
 *
 * Routing was extracted to `core.routes.ts` (Phase 11 #8) and is wired via the
 * root `provideRouter(appRoutes)` call in `app.config.ts`.
 */
@NgModule({
    exports: [],
    imports: [CommonModule, NzLayoutModule, NzButtonModule, NzImageModule, NzSpinModule, LandingComponent],
})
export class CoreModule {}
